<template>
  <div :class="['row', margin || 'mb-4']">
    <label :for="id" :class="`col-sm-${cols || 4} font-weight-bold`">{{ labelText }}:</label>
    <div :id="id" :class="`col-sm-${12 - (cols || 4)}`" v-html="value" />
  </div>
</template>

<script>
  export default {
    name: "StaticFormControl",
    props: {
      labelText: {
        type: String,
        required: false,
      },
      id: {
        type: String,
        required: true,
      },
      value: {
        required: true,
      },
      cols: {
        type: Number,
        required: false,
        default: 4,
      },
      margin: {
        type: String,
        required: false,
        default: "mb-4",
      },
    },
  };
</script>
